import { LockError } from '@/utils/LockError';

export class Base64 {
  public static decode(value: string): string {
    try {
      if (typeof window !== 'undefined' && window.atob)
        return window.atob(value);
      return Buffer.from(value, 'base64').toString('utf-8');
    } catch (error: unknown) {
      throw new LockError('Decode error', (error as any).message);
    }
  }
}
